'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enum = require('@vezeeta/enterprise-utils/lib/enum');

var _activities = require('../actions/activities');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  activitiesReservations: {
    islastPage: false
  },
  activitiesReservationsState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _activities.ACTIVITIES.ACTIVITIES_RESERVATION.RESET:
      {
        return _extends({}, state, {
          activitiesReservations: {
            islastPage: false
          },
          activitiesReservationsState: _enum.status.SHOULD_CALL_API
        });
      }
    case _activities.ACTIVITIES.ACTIVITIES_RESERVATION.LOAD:
      {
        var activitiesObj = void 0;
        if (payload.payload && payload.payload.Page === 1) {
          activitiesObj = payload.payload;
        } else {
          var activitiesReservations = state.activitiesReservations;

          activitiesObj = _extends({}, activitiesReservations, payload.payload);
        }

        return _extends({}, state, {
          activitiesReservations: activitiesObj,
          activitiesReservationsState: _enum.status.FETCHING
        });
      }

    case _activities.ACTIVITIES.ACTIVITIES_RESERVATION.SUCCESS:
      {
        var _activitiesObj = void 0;

        if (payload.payload && payload.payload.Page === 1) {
          _activitiesObj = _extends({}, payload.payload, {
            islastPage: payload.payload.Reservations && payload.payload.Reservations.length < 10 || !payload.payload.Reservations.length
          });
        } else {
          var _activitiesReservations = state.activitiesReservations;
          var Reservations = _activitiesReservations.Reservations;

          _activitiesObj = _extends({}, _activitiesReservations, {
            Reservations: [].concat(Reservations, payload.payload.Reservations),
            islastPage: payload.payload.Reservations && payload.payload.Reservations.length < 10 || !payload.payload.Reservations.length
          });
        }

        return _extends({}, state, {
          activitiesReservations: _activitiesObj,
          activitiesReservationsState: _enum.status.SUCCESS
        });
      }

    case _activities.ACTIVITIES.ACTIVITIES_RESERVATION.FAIL:
      {
        var _activitiesReservations2 = state.activitiesReservations;

        var _activitiesObj2 = _extends({}, _activitiesReservations2, {
          islastPage: true
        });
        return _extends({}, state, {
          activitiesReservations: _activitiesObj2,
          activitiesReservationsState: _enum.status.FAIL
        });
      }

    default:
      return state;
  }
};

module.exports = exports['default'];